import React, { useEffect, useState } from 'react';
import { BaSeIcon, BaSeLoadingPage, BaSeErrorPage } from '@base/react';
import DashBoardModel, { opcoes } from './dashboard.model';
import './dashboard.scss';
import styles from './styles.module.scss';
import {
  CustomGraphBar,
  GeneralGraphBar,
  CircularGraph,
  VictoryGraph,
} from '../../utils/graphs';
import 'react-circular-progressbar/dist/styles.css';
import {
  FaRegBell,
  FaRegAddressCard,
  FaLightbulb,
  FaRegCalendarAlt,
  FaChartBar,
  FaSlidersH,
  FaQuestionCircle,
  FaUser,
  FaColumns,
} from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { TfiReload } from 'react-icons/tfi';

import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Calendar } from 'react-modern-calendar-datepicker';
import DashboardRegistroSas from './DashboardRegistroSas';
import AtendimentosSSE from './AtendimentosSSE';
import Usuarios from './Usuarios';
import { formatDateToBR } from '../../utils/time';
import moment from 'moment';
import Acessos from './Acessos';
import { useApp } from '../../context/app';
import { InitialPage } from './InitialPage/initialPage';
import Recorrencias from './Recorrencias';
import {
  Box,
  Button,
  Drawer,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';

const ICON_SIZE = 16;

const myCustomLocale = {
  // months list by order
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],

  // week days by order
  weekDays: [
    {
      name: 'Domingo', // used for accessibility
      short: 'D', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: 'Segunda',
      short: 'S',
    },
    {
      name: 'terça',
      short: 'T',
    },
    {
      name: 'Quarta',
      short: 'Q',
    },
    {
      name: 'Quinta',
      short: 'Q',
    },
    {
      name: 'Sexta',
      short: 'S',
    },
    {
      name: 'Sábado',
      short: 'S',
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  defaultPlaceholder: 'Select...',

  // for input range value
  from: 'from',
  to: 'to',

  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

const Dashboard = () => {
  const { filtersDashboard, setFiltersDashboard } = useApp();
  const [showDialog, setShowDialog] = useState(false);
  // const buttonRef = useRef();
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const [labelSideMenu, setLabelSideMenu] = useState('Personalizado');

  const {
    selectedNavBar,
    updateSelectedBar,
    data,
    isAdmin,
    resumo,
    isLoading,
    isError,
    history,
    filterOptions,
    filters,
    cidades,
    setFilters,
    setFirstRender,
    cleanFilters,
    cleanCache,
    getCidades,
    handleApplyRangeDate,
    setAllLoadingTrue,
    isCleanerCache,

    // START LOADING SAS------------------------------------------------------------
    isLoadingSas,
    isLoadingUserUnico,
    isLoadingPerfilUser,
    isLoadingPorcemPerfilUserUnico,
    isLoadingMediaAtendiUser,
    isLoadingMediaAtendUserPf,
    isLoadingMediaAtendUserPj,
    isLoadingPorteTipoInstru,
    isLoadingAtendPorte,
    isLoadingMediaAtendPorte,
    isLoadingAtendHora,
    isLoadingAPC,
    isLoadingAPS,
    isLoadingAPB,
    isLoadingAPM,
    isLoadingAPA,
    isLoadingAPD,
    isLoadingAPL,
    isLoadingAPR,
    isLoadingAPE,
    isLoadingAPN,
    isLoadingAPF,
    isLoadingAPO,
    isLoadingStatusEnvioSAS,
    isLoadingPorcemEnvioSAS,
    isLoadingEnvioInstrumentoSAS,
    isLoadingRecorrenciaPjSas,
    isLoadingRecorrenciaPjMeiSas,
    isLoadingRecorrenciaPjMeSas,
    isLoadingRecorrenciaPjEppSas,
    // END LOADING SAS------------------------------------------------------------

    // START SAS AREA------------------------------------------------------------
    registroSas,
    usuariosUnicos,
    perfilUsuario,
    porcemPerfilUsuarioUnico,
    mediaAtendimentoUsuario,
    mediaAtendimentoUsuarioPf,
    mediaAtendimentoUsuarioPj,
    porteTipoInstrumento,
    mediaAtendimentoPorte,
    atendimentoPorte,
    atendimentosHora,
    atendimentoUf,
    tipoAtendimentoAPC,
    tipoAtendimentoAPS,
    tipoAtendimentoAPB,
    tipoAtendimentoAPM,
    tipoAtendimentoAPA,
    tipoAtendimentoAPD,
    tipoAtendimentoAPL,
    tipoAtendimentoAPR,
    tipoAtendimentoAPE,
    tipoAtendimentoAPN,
    tipoAtendimentoAPF,
    tipoAtendimentoAPO,
    statusEnvioSAS,
    porcemEnvioSAS,
    envioInstrumentoSAS,
    recorrenciaPjSas,
    recorrenciaPjMeiSas,
    recorrenciaPjMeSas,
    recorrenciaPjEppSas,
    // END SAS AREA------------------------------------------------------------

    //START SSE AREA------------------------------------------------------------
    usuariosApp,
    total,
    statusEnvio,
    porte,
    porteMei,
    porteMe,
    porteEpp,
    porcemUsuariosApp,
    porcemStatusEnvio,
    hora,
    hoje,
    dia,
    ufCidadeAtendente,
    recorrenciaPjSse,
    semAnotacao,
    semPlanoAcao,
    semFoto,
    semArquivo,
    // END SSE AREA-------------------------------------------------------------

    // START LOADING SSE------------------------------------------------------------
    isLoadingUsuariosApp,
    isLoadingTotal,
    isLoadingStatusEnvio,
    isLoadingPorte,
    isLoadingPorteMei,
    isLoadingPorteMe,
    isLoadingPorcemUsuariosApp,
    isLoadingPorteEpp,
    isLoadingPorcemStatusEnvio,
    isLoadingHora,
    isLoadingHoje,
    isLoadingDia,
    isLoadingUfCidadeAtendente,
    isLoadingRecorrenciaPjSse,
    isLoadingSemAnotacao,
    isLoadingSemPlanoAcao,
    isLoadingSemFoto,
    isLoadingSemArquivo,
    // END LOADING SSE------------------------------------------------------------

    // START USUARIO AREA------------------------------------------------------------
    totalUser,
    novosUser,
    PfUser,
    PjUser,
    PjMeiUser,
    PjMeUser,
    PjEppUser,
    PjOutrosUser,
    AtivosAgoraUser,
    AtivosAgoraPfUser,
    AtivosAgoraPjUser,
    ufUser,

    isLoadingTotalUser,
    isLoadingNovosUser,
    isLoadingPfUser,
    isLoadingPjUser,
    isLoadingPjMeiUser,
    isLoadingPjMeUser,
    isLoadingPjEppUser,
    isLoadingPjOutrosUser,
    isLoadingAtivosAgoraUser,
    isLoadingAtivosAgoraPfUser,
    isLoadingAtivosAgoraPjUser,
    isLoadingUfUser,
    // END USUARIO AREA------------------------------------------------------------

    // START ACESSOS AREA------------------------------------------------------------
    totalAcessos,
    usuariosUnicosAcessos,
    mediaUsuarioAcessos,
    distribuicaoDiaAcessos,
    perfilUsuarioAcessos,
    porcemPerfilUserAcessos,
    porteAcessos,
    tempoMedioAcessos,
    ufAcessos,

    isLoadingTotalAcessos,
    isLoadingUsuariosUnicosAcessos,
    isLoadingMediaUsuarioAcessos,
    isLoadingDistribuicaoDiaAcessos,
    isLoadingPerfilUsuariosAcessos,
    isLoadingPorcemPerfilUserAcessos,
    isLoadingPorteAcessos,
    isLoadingTempoMedioAcessos,
    isLoadingUfAcessos,
    isLoadingUfUnicoAcessos,
    // END ACESSOS AREA------------------------------------------------------------
  } = DashBoardModel();

  // pegar ano atual com o moment e subtrair 2019
  const anoAtual = moment().format('YYYY');
  const anoAtualSubtrair = Number(anoAtual) - 2019;

  const sideMenu = [
    {
      label: 'Hoje',
      onPress: () => {
        setLabelSideMenu('Hoje');
        const data = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(data[0]),
            month: Number(data[1]),
            day: Number(data[2]),
          },
          to: {
            year: Number(data[0]),
            month: Number(data[1]),
            day: Number(data[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${data[0]}-${data[1]}-${data[2]}`,
            dataFinal: `${data[0]}-${data[1]}-${data[2]}`,
          },
        });
      },
    },
    {
      label: 'Ontem',
      onPress: () => {
        setLabelSideMenu('Ontem');
        const data = moment().add(-1, 'days').format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(data[0]),
            month: Number(data[1]),
            day: Number(data[2]),
          },
          to: {
            year: Number(data[0]),
            month: Number(data[1]),
            day: Number(data[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${data[0]}-${data[1]}-${data[2]}`,
            dataFinal: `${data[0]}-${data[1]}-${data[2]}`,
          },
        });
      },
    },

    {
      label: 'Esta semana',
      onPress: () => {
        setLabelSideMenu('Esta semana');
        const dataStart = moment()
          .startOf('isoWeek')
          .format('YYYY-MM-DD')
          .split('-');

        const dataEnd = moment()
          .endOf('isoWeek')
          .format('YYYY-MM-DD')
          .split('-');

        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Semana Passada',
      onPress: () => {
        setLabelSideMenu('Semana Passada');
        const dataStart = moment()
          .subtract(1, 'weeks')
          .startOf('isoWeek')
          .format('YYYY-MM-DD')
          .split('-');

        const dataEnd = moment()
          .subtract(1, 'weeks')
          .endOf('isoWeek')
          .format('YYYY-MM-DD')
          .split('-');

        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Últimos 7 dias',
      onPress: () => {
        setLabelSideMenu('Últimos 7 dias');
        const dataStart = moment()
          .add(-6, 'days')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Últimos 28 dias',
      onPress: () => {
        setLabelSideMenu('Últimos 28 dias');
        const dataStart = moment()
          .add(-27, 'days')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Últimos 30 dias',
      onPress: () => {
        setLabelSideMenu('Últimos 30 dias');
        const dataStart = moment()
          .add(-29, 'days')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Últimos 90 dias',
      onPress: () => {
        setLabelSideMenu('Últimos 90 dias');
        const dataStart = moment()
          .add(-89, 'days')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Últimos 12 meses',
      onPress: () => {
        setLabelSideMenu('Últimos 12 meses');
        const dataStart = moment()
          .subtract(12, 'months')
          .startOf('month')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Ano passado',
      onPress: () => {
        setLabelSideMenu('Ano passado');
        const dataStart = moment()
          .subtract(1, 'year')
          .startOf('year')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment()
          .subtract(1, 'year')
          .endOf('year')
          .format('YYYY-MM-DD')
          .split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Este ano (Jan - Hoje)',
      onPress: () => {
        setLabelSideMenu('Este ano (Jan - Hoje)');
        const dataStart = moment()
          .startOf('year')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },
    {
      label: 'Consolidado (2019 - Hoje)',
      onPress: () => {
        setLabelSideMenu('Consolidado (2019 - Hoje)');
        const dataStart = moment()
          .subtract(anoAtualSubtrair, 'year')
          .startOf('year')
          .format('YYYY-MM-DD')
          .split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },

    {
      label: 'Personalizado',
      onPress: () => {
        setLabelSideMenu('Personalizado');
        const dataStart = moment().format('YYYY-MM-DD').split('-');
        const dataEnd = moment().format('YYYY-MM-DD').split('-');
        setSelectedDayRange({
          from: {
            year: Number(dataStart[0]),
            month: Number(dataStart[1]),
            day: Number(dataStart[2]),
          },
          to: {
            year: Number(dataEnd[0]),
            month: Number(dataEnd[1]),
            day: Number(dataEnd[2]),
          },
        });
        setFilters({
          type: 'filters',
          data: {
            ...filters.filters,
            dataInicial: `${dataStart[0]}-${dataStart[1]}-${dataStart[2]}`,
            dataFinal: `${dataEnd[0]}-${dataEnd[1]}-${dataEnd[2]}`,
          },
        });
      },
    },
  ];

  // const dataModalFilterStart = moment().format('YYYY-MM-DD').split('-');
  const dataModalFilterStart = moment()
    .startOf('year')
    .format('YYYY-MM-DD')
    .split('-');
  const dataModalFilterEnd = moment().format('YYYY-MM-DD').split('-');
  const defaultFrom = {
    year: Number(dataModalFilterStart[0]),
    month: Number(dataModalFilterStart[1]),
    day: Number(dataModalFilterStart[2]),
  };

  const defaultTo = {
    year: Number(dataModalFilterEnd[0]),
    month: Number(dataModalFilterEnd[1]),
    day: Number(dataModalFilterEnd[2]),
  };

  const defaultRange = {
    from: defaultFrom,
    to: defaultTo,
  };

  const [selectedDayRange, setSelectedDayRange] = useState(defaultRange);
  const [isCleaner, setIsCleaner] = useState(false);

  // prettier-ignore
  useEffect(_ => {

    setLabelSideMenu('Este ano (Jan - Hoje)');
    // setFilters({ type: 'filters', data: {} });
    setFilters({
      type: 'filters',
      data: {
        ...filters.filters,
        dataInicial: `${dataModalFilterStart[0]}-${dataModalFilterStart[1]}-${dataModalFilterStart[2]}`,
        dataFinal: `${dataModalFilterEnd[0]}-${dataModalFilterEnd[1]}-${dataModalFilterEnd[2]}`,
      },
    });
    setSelectedDayRange(defaultRange);

    if (isCleaner) {
      setSelectedDayRange(defaultRange);
      setIsCleaner(false)
    }

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNavBar, isCleaner]);

  const renderFilter = () => (
    <Stack
      direction={{ sx: 'column', lg: 'row' }}
      justifyContent="flex-end"
      sx={{ marginBottom: '2rem' }}
    >
      <Box
        sx={{ fontSize: '16px', fontWeight: 'bold', display: { xs: 'none' } }}
      >
        {opcoes[selectedNavBar].name}
      </Box>
      <Stack direction={{ xs: 'column', md: 'row', lg: 'row' }}>
        <Stack
          direction="row"
          sx={{
            marginBottom: {
              xs: '1rem',
            },
            marginTop: '1rem',
          }}
        >
          {!!isAdmin && opcoes[selectedNavBar].name === 'Atendimentos SSE' && (
            <div
              className="dashboard-close-filter-container"
              onClick={(e) => {
                setIsCleaner(true);
                cleanCache();
              }}
            >
              <label className="title-accordion-component-filter">
                <div>
                  {isCleanerCache ? (
                    <div className="rotate-icon">
                      <TfiReload size={14} color="#33cc99" />
                    </div>
                  ) : (
                    <TfiReload size={14} color="#33cc99" />
                  )}
                </div>{' '}
                Limpar cache
              </label>
            </div>
          )}

          <div
            className="dashboard-close-filter-container"
            onClick={(e) => {
              setIsCleaner(true);
              cleanFilters();
            }}
          >
            <label className="title-accordion-component-filter">
              <div>
                <AiOutlineCloseCircle size={14} color="#cc3366" />{' '}
              </div>{' '}
              Limpar filtros
            </label>
          </div>

          {/* Dialog Filters */}
          <DialogOverlay
            isOpen={showDialog}
            onDismiss={close}
            style={{ zIndex: 250 }}
          >
            <DialogContent
              className="dialog-modal"
              aria-labelledby="grid-container"
            >
              <div className="grid-container">
                <div className="grid-item item2">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: -5,
                    }}
                  >
                    <div>
                      <p className="personalizado-range-dataLabel">
                        {labelSideMenu}
                      </p>
                      <div className="personalizado-range-data">
                        <p
                          className="personalizado-range-data"
                          style={{
                            background:
                              filters?.filters?.dataInicial ||
                              filters?.filters?.dataFinal
                                ? '#DDF8FF'
                                : 'transparent',
                          }}
                        >
                          {filters?.filters?.dataInicial ||
                          filters?.filters?.dataFinal
                            ? `${formatDateToBR(filters?.filters?.dataInicial)}`
                            : ''}
                        </p>
                        <span style={{ margin: 2, fontSize: 13 }}>
                          {filters?.filters?.dataInicial ||
                          filters?.filters?.dataFinal
                            ? '-'
                            : ''}
                        </span>

                        <p
                          className="personalizado-range-data"
                          style={{
                            background:
                              filters?.filters?.dataInicial ||
                              filters?.filters?.dataFinal
                                ? '#DDF8FF'
                                : 'transparent',
                          }}
                        >
                          {filters?.filters?.dataInicial ||
                          filters?.filters?.dataFinal
                            ? `${formatDateToBR(filters?.filters?.dataFinal)}`
                            : ''}
                        </p>
                      </div>
                    </div>
                    <div className="close-icon-range-date">
                      <AiOutlineCloseCircle
                        style={{ color: '#bdbdbd', fontWeight: 'bold' }}
                        onClick={close}
                      />
                    </div>
                  </div>

                  <Calendar
                    className="calendar"
                    value={selectedDayRange}
                    // onChange={setSelectedDayRange}
                    onChange={(item) => {
                      setSelectedDayRange(item);
                      const dataStart = item.from;
                      const dataEnd = item.to;

                      dataStart && dataEnd && handleApplyRangeDate(item);
                    }}
                    colorPrimary="#0fbcf9"
                    colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                    calendarClassName={styles.responsive_calendar}
                    locale={myCustomLocale}
                    shouldHighlightWeekends
                  />
                </div>

                <div className="grid-item item1">
                  {sideMenu.map((item, index) => (
                    <p
                      key={index.toString()}
                      onClick={item.onPress}
                      style={{
                        cursor: 'pointer',
                        color:
                          item.label === labelSideMenu ? '#18A0FB' : '#000',
                      }}
                    >
                      {item.label}
                    </p>
                  ))}
                </div>
              </div>
              <hr className="divisor" />

              <div className="buttonSpan">
                <span className="cancel" onClick={close}>
                  Cancelar
                </span>
                <button
                  className={
                    !selectedDayRange.to || !selectedDayRange.from
                      ? 'apply-disable'
                      : 'apply'
                  }
                  disabled={!selectedDayRange.to || !selectedDayRange.from}
                  onClick={(e) => {
                    handleApplyRangeDate(selectedDayRange);
                    close();
                  }}
                >
                  Aplicar
                </button>
              </div>
            </DialogContent>
          </DialogOverlay>

          <label
            className="report-label"
            onClick={() => {
              const routeToUrl = {
                acessos: '/reports/Acessos',
                agendamentos: '/reports/Agendamentos',
                nans: '/reports/AtendimentosSse',
                devolutivas: '/reports/Diagnosticos',
                'registros-atendimento': '/reports/RegistroSas',
                usuarios: '/reports/Usuarios',
              };
              const selectedRoute = opcoes[selectedNavBar].route;
              let url = routeToUrl[selectedRoute] || '';

              const params = {}
              if (filtersDashboard?.cidadesValueSelect?.nome) {
                params.cidade = filtersDashboard?.cidadesValueSelect?.nome;
              }
              if (filtersDashboard?.ufValueSelect?.sigla) {
                params.uf = filtersDashboard?.ufValueSelect?.sigla;
              }
              if (filters?.filters?.dataInicial) {
                params.dataInicial = filters?.filters?.dataInicial;
              }
              if (filters?.filters?.dataFinal) {
                params.dataFinal = filters?.filters?.dataFinal;
              }

              if (Object.keys(params).length > 0) {
                url += '?' + new URLSearchParams(params).toString();
              }
              history.push(url)
            }}
          >
            <div>
              <AiOutlineCheckCircle size={14} color="#00ccff" />{' '}
            </div>{' '}
            Ir para relatório...
          </label>
        </Stack>

        <Stack
          direction={{ xs: 'column', md: 'row', lg: 'row' }}
          sx={{
            bgcolor: '#dff4f9',
            padding: '3px',
            marginLeft: { xs: '0', md: '0.5rem', lg: '0.5rem' },
            borderRadius: '8px',
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 70 }} size="small">
            <InputLabel id="demo-simple-select-label">UF</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="UF"
              className="correct-color"
              value={filters?.filters?.ufs?.[0]?.id | ''}
              onChange={(event) => {
                getCidades(event.target.value);
              }}
              sx={{ bgcolor: '#fff' }}
            >
              {filterOptions?.ufs
                ?.sort(function (a, b) {
                  return a.sigla > b.sigla ? 1 : -1;
                })
                .map((uf) => (
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    key={uf.id.toString()}
                    value={uf.id}
                    title={uf.sigla}
                  >
                    {uf.sigla}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="demo-select-small-label-cidades">
              Cidades
            </InputLabel>
            <Select
              labelId="demo-select-small-label-cidades"
              id="demo-select-small-cidades"
              label="Cidades"
              sx={{ bgcolor: '#fff' }}
              value={filters?.filters?.cidades?.[0]?.id | ''}
              className="correct-color"
              onChange={(event) => {
                const id = event.target.value;
                const recovery = cidades.find(
                  (each) => each.id === parseInt(id)
                );
                setFiltersDashboard({
                  ...filtersDashboard,
                  cidades: [recovery],
                  cidadesValueSelect: recovery,
                });
                setFilters({
                  type: 'filters',
                  data: { ...filters.filters, cidades: [recovery] },
                });
                setAllLoadingTrue(true);
                setFirstRender(true);
              }}
            >
              {cidades
                ?.sort(function (a, b) {
                  return a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0;
                })
                .map((cidade) => (
                  <MenuItem
                    sx={{ fontSize: '12px' }}
                    key={cidade.id.toString()}
                    value={cidade.id}
                    title={cidade.nome}
                  >
                    {cidade.nome}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <Stack
            sx={{
              m: 1,
              minWidth: 150,
              bgcolor: '#fff',
              color: '#9d9d9d',
              border: '1px solid #9d9d9d',
              borderRadius: '5px',
              fontSize: '12px',
              fontWeight: 'bold',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            className="correct-color"
            onClick={open}
          >
            {filters?.filters?.dataInicial || filters?.filters?.dataFinal
              ? `${formatDateToBR(
                  filters?.filters?.dataInicial
                )} - ${formatDateToBR(filters?.filters?.dataFinal)}`
              : 'Selecionar Período'}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );

  const renderDash = (el) => {
    if (el.label === 'Top#10 registros por UF') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 registros por UF"
          tooltipTitle="Top#10 registros por UF"
        />
      );
    } else if (el.label === 'Top#10 Acessos por UF') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 acessos por UF"
          tooltipTitle="Top#10 acessos por UF"
        />
      );
    } else if (el.label === 'Top#10 diagnósticos por UF') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 diagnósticos por UF"
          tooltipTitle="Top#10 diagnósticos por UF"
        />
      );
    } else if (el.label === 'Top#10 cidades agendamentos') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 cidades agendamentos"
          tooltipTitle="Top#10 cidades agendamentos"
        />
      );
    } else if (el.label === 'Top#10 SEBRAE atendentes') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 SEBRAE atendentes"
          tooltipTitle="Top#10 SEBRAE atendentes"
        />
      );
    } else if (el.label === 'Top#10 agentes NAN') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 agentes NAN"
          tooltipTitle="Top#10 agentes NAN"
        />
      );
    } else if (el.label === 'Top#10 Usuários por UF') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 usuários por UF"
          tooltipTitle="Top#10 usuários por UF"
        />
      );
    } else if (el.label === 'Atendimentos por porte') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Atendimentos por porte"
          tooltipTitle="Atendimentos por porte"
        />
      );
    } else if (el.label === 'TOP#10 Cidades agendamentos') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 cidades agendamentos"
          tooltipTitle="Top#10 cidades agendamentos"
        />
      );
    } else if (el.label === 'TOP#10 Sebrae Atendentes') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 sebrae Atendentes"
          tooltipTitle="Top#10 sebrae Atendentes"
        />
      );
    } else if (el.label === 'Top#10 Cidades') {
      return (
        <CustomGraphBar
          enableTooltip
          el={el}
          dashTitle="Top#3 cidades"
          tooltipTitle="Top#10 cidades"
        />
      );
    } else {
      return <GeneralGraphBar el={el} />;
    }
  };

  const renderDestaqueContainer = () => (
    <div className="destaque-container novo">
      <label>Destaques</label>
      <div className="destaque-content">
        <table>
          <tbody>
            {isLoading.resumo && (
              <tr>
                <td
                  style={{
                    backgroundColor: resumo.carrosseis > 0 ? '#E0F7F0' : '#fff',
                  }}
                >
                  <BaSeLoadingPage />
                </td>
              </tr>
            )}

            {!isLoading.resumo && (
              <>
                <tr>
                  <td
                    style={{
                      backgroundColor:
                        resumo.carrosseis > 0 ? '#E0F7F0' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaSlidersH size={ICON_SIZE} color="#33CC99" />
                      <h4>Carrosséis</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.carrosseis > 0 ? (
                            <strong
                              style={{ color: '#33CC99' }}
                            >{` ${resumo.carrosseis} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          carrossel(is) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        resumo.gestaoUsuarios > 0 ? '#E6F0FB' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaUser size={ICON_SIZE} color="#0062C7" />
                      <h4>Gestão de Usuários</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.gestaoUsuarios > 0 ? (
                            <strong
                              style={{ color: '#0062C7' }}
                            >{` ${resumo.gestaoUsuarios} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          usuário(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="td-wrapper">
                      <FaSlidersH size={ICON_SIZE} color="#9999FF" />
                      <h4>Cupons</h4>
                      <label>
                        <i>Área em construção</i>
                      </label>
                    </div>
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        resumo.notificacoes > 0 ? '#FFF0E0' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaRegBell size={ICON_SIZE} color="#FF9933" />
                      <h4>Notificações</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.notificacoes > 0 ? (
                            <strong
                              style={{ color: '#FF9933' }}
                            >{` ${resumo.notificacoes} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          notificação(ões) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor:
                        resumo.diagnosticos > 0 ? '#F7E8F7' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaChartBar size={ICON_SIZE} color="#CC66CC" />
                      <h4>Diagnosticos</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.diagnosticos > 0 ? (
                            <strong
                              style={{ color: '#CC66CC' }}
                            >{` ${resumo.diagnosticos} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          diagnóstico(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        resumo.novidades > 0 ? '#F2F6FF' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaRegAddressCard size={ICON_SIZE} color="#6699FF" />
                      <h4>Novidades</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.novidades > 0 ? (
                            <strong
                              style={{ color: '#6699FF' }}
                            >{` ${resumo.novidades} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          novidade(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: resumo.eventos > 0 ? '#FFE6E6' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaRegCalendarAlt size={ICON_SIZE} color="#FF0000" />
                      <h4>Eventos</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.eventos > 0 ? (
                            <strong
                              style={{ color: '#FF0000' }}
                            >{` ${resumo.eventos} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          evento(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>

                  <td
                    style={{
                      backgroundColor:
                        resumo.perguntasFrequentes > 0 ? '#F7E8E0' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaQuestionCircle size={ICON_SIZE} color="#CC6633" />
                      <h4>Perguntas Frequentes</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.perguntasFrequentes > 0 ? (
                            <strong
                              style={{ color: '#CC6633' }}
                            >{` ${resumo.perguntasFrequentes} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          pergunta(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor:
                        resumo.funcionalidades > 0 ? '#FBEBF0' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaColumns size={ICON_SIZE} color="#CC3366" />
                      <h4>Funcionalidades</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.funcionalidades > 0 ? (
                            <strong
                              style={{ color: '#CC3366' }}
                            >{` ${resumo.funcionalidades} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          funcionalidade(s) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        resumo.permissoesAcesso > 0 ? '#F7F7E0' : '#fff',
                    }}
                  >
                    <div className="td-wrapper">
                      <FaLightbulb size={ICON_SIZE} color="#CCCC33" />
                      <h4>Permissões de Acesso</h4>
                      <label>
                        <i>
                          Existem
                          {resumo.permissoesAcesso > 0 ? (
                            <strong
                              style={{ color: '#CCCC33' }}
                            >{` ${resumo.permissoesAcesso} `}</strong>
                          ) : (
                            ' 0 '
                          )}
                          permissão(ões) para aprovação.
                        </i>
                      </label>
                    </div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderHeader = () => {
    return (
      <div className="modal-header">
        <div className="modal-flex-direction-row">
          <svg
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M35.3349 15.7931L35.3321 15.7903L20.519 0.979277C19.8876 0.347664 19.0481 0 18.1552 0C17.2623 0 16.4228 0.347664 15.7911 0.979277L0.985786 15.7828C0.980799 15.7878 0.975535 15.7931 0.970825 15.7981C-0.325775 17.102 -0.323559 19.2177 0.977197 20.5183C1.57147 21.1128 2.35608 21.4568 3.19527 21.4931C3.22962 21.4965 3.26398 21.4981 3.29861 21.4981H3.88873V32.3979C3.88873 34.5551 5.64413 36.31 7.80153 36.31H13.5969C14.1845 36.31 14.6608 35.8335 14.6608 35.2462V26.7006C14.6608 25.7164 15.4617 24.9158 16.4461 24.9158H19.8643C20.8487 24.9158 21.6494 25.7164 21.6494 26.7006V35.2462C21.6494 35.8335 22.1256 36.31 22.7133 36.31H28.5086C30.6663 36.31 32.4214 34.5551 32.4214 32.3979V21.4981H32.9689C33.8615 21.4981 34.701 21.1505 35.3329 20.5186C36.6351 19.216 36.6356 17.0965 35.3349 15.7931ZM33.8283 19.0143C33.5986 19.244 33.2933 19.3706 32.9689 19.3706H31.3575C30.7699 19.3706 30.2937 19.8468 30.2937 20.4343V32.3979C30.2937 33.3819 29.493 34.1825 28.5086 34.1825H23.7771V26.7006C23.7771 24.5434 22.022 22.7882 19.8643 22.7882H16.4461C14.2884 22.7882 12.533 24.5434 12.533 26.7006V34.1825H7.80153C6.81744 34.1825 6.01648 33.3819 6.01648 32.3979V20.4343C6.01648 19.8468 5.54023 19.3706 4.95261 19.3706H3.36898C3.35236 19.3695 3.33601 19.3686 3.31911 19.3684C3.00217 19.3628 2.70489 19.2371 2.48214 19.014C2.00838 18.5403 2.00838 17.7694 2.48214 17.2954L17.2961 2.48351C17.5255 2.25386 17.8305 2.12754 18.1552 2.12754C18.4796 2.12754 18.7847 2.25386 19.0143 2.48351L33.8236 17.291L33.8305 17.2976C34.3018 17.7722 34.3009 18.5414 33.8283 19.0143Z"
              fill="white"
            />
          </svg>

          <h2 className="text-color-branco-titulo">Dashboard</h2>
        </div>
      </div>
    );
  };

  function handleOpen() {
    setOpenDrawer(!openDrawer);
  }

  function handleClose() {
    setOpenDrawer(false);
  }

  const renderInfoContainer = () => (
    <div className="info-container">
      <div className="relatorio-container">
        <div className="icone-wrapper">
          <BaSeIcon
            name="chart-pie-alt"
            size={35}
            description="Ícone de relatório"
            color="#25D0F4"
          />
        </div>
        <ul className="relatorio-list">
          {opcoes.map((op, i) => (
            <li
              key={i.toString()}
              className={`${
                op.label === 'relatorios'
                  ? 'selected-initial-nav'
                  : selectedNavBar === i
                  ? 'selected-nav'
                  : undefined
              } relatorios-list-map`}
              onClick={() => updateSelectedBar(i)}
            >
              {op.name}
            </li>
          ))}
        </ul>
      </div>
      <div className="dropdown responsive-menu-dropdown">
        <Button onClick={handleOpen}>
          {opcoes[selectedNavBar].name} <MdKeyboardArrowDown />
        </Button>
        <Drawer anchor={'left'} open={openDrawer} onClose={handleClose}>
          {opcoes.map((op, i) => (
            <MenuItem
              onClick={() => {
                updateSelectedBar(i);
                handleClose();
              }}
              key={i}
            >
              {op.name}
            </MenuItem>
          ))}
        </Drawer>
        {/* <button className="dropbtn" >
          {opcoes[selectedNavBar].name} <MdKeyboardArrowDown />
        </button> */}
        {/* {opcoes.map((op, i) => {
          return (
            <div className="dropdown-content" key={i.toString()}>
              <li
                className={`${
                  selectedNavBar === i ? 'selected-nav' : undefined
                } `}
                onClick={() => updateSelectedBar(i)}
              >
                {op.name}
              </li>
            </div>
          );
        })} */}
      </div>

      <div className="values-diagnostico">
        {opcoes[selectedNavBar].name !== 'Relatórios' && renderFilter()}
        <div className="info-box-container">
          {opcoes[selectedNavBar].name === 'Relatórios' && <InitialPage />}

          {opcoes[selectedNavBar].name === 'Registros (SAS)' && (
            <DashboardRegistroSas
              {...{
                registroSas,
                usuariosUnicos,
                perfilUsuario,
                porcemPerfilUsuarioUnico,
                mediaAtendimentoUsuario,
                mediaAtendimentoUsuarioPf,
                mediaAtendimentoUsuarioPj,
                porteTipoInstrumento,
                mediaAtendimentoPorte,
                atendimentoPorte,
                atendimentosHora,
                atendimentoUf,
                tipoAtendimentoAPC,
                tipoAtendimentoAPS,
                tipoAtendimentoAPB,
                tipoAtendimentoAPM,
                tipoAtendimentoAPA,
                tipoAtendimentoAPD,
                tipoAtendimentoAPL,
                tipoAtendimentoAPR,
                tipoAtendimentoAPE,
                tipoAtendimentoAPN,
                tipoAtendimentoAPF,
                tipoAtendimentoAPO,
                statusEnvioSAS,
                porcemEnvioSAS,
                envioInstrumentoSAS,
                recorrenciaPjSas,
                recorrenciaPjMeiSas,
                recorrenciaPjMeSas,
                recorrenciaPjEppSas,
                isLoading,
                isError,
                isLoadingSas,
                isLoadingUserUnico,
                isLoadingPerfilUser,
                isLoadingPorcemPerfilUserUnico,
                isLoadingMediaAtendiUser,
                isLoadingMediaAtendUserPf,
                isLoadingMediaAtendUserPj,
                isLoadingPorteTipoInstru,
                isLoadingAtendPorte,
                isLoadingMediaAtendPorte,
                isLoadingAtendHora,
                isLoadingAPC,
                isLoadingAPS,
                isLoadingAPB,
                isLoadingAPM,
                isLoadingAPA,
                isLoadingAPD,
                isLoadingAPL,
                isLoadingAPR,
                isLoadingAPE,
                isLoadingAPN,
                isLoadingAPF,
                isLoadingAPO,
                isLoadingStatusEnvioSAS,
                isLoadingPorcemEnvioSAS,
                isLoadingEnvioInstrumentoSAS,
                isLoadingRecorrenciaPjSas,
                isLoadingRecorrenciaPjMeiSas,
                isLoadingRecorrenciaPjMeSas,
                isLoadingRecorrenciaPjEppSas,
              }}
            />
          )}

          {opcoes[selectedNavBar].name === 'Atendimentos SSE' && (
            <AtendimentosSSE
              {...{
                usuariosApp,
                total,
                statusEnvio,
                porte,
                porteMei,
                porteMe,
                porteEpp,
                porcemUsuariosApp,
                porcemStatusEnvio,
                hora,
                hoje,
                dia,
                ufCidadeAtendente,
                recorrenciaPjSse,
                semAnotacao,
                semPlanoAcao,
                semFoto,
                semArquivo,
                isLoadingUsuariosApp,
                isLoadingTotal,
                isLoadingStatusEnvio,
                isLoadingPorte,
                isLoadingPorteMei,
                isLoadingPorteMe,
                isLoadingPorcemUsuariosApp,
                isLoadingPorteEpp,
                isLoadingPorcemStatusEnvio,
                isLoadingHora,
                isLoadingHoje,
                isLoadingDia,
                isLoadingUfCidadeAtendente,
                isLoadingRecorrenciaPjSse,
                isLoadingSemAnotacao,
                isLoadingSemPlanoAcao,
                isLoadingSemFoto,
                isLoadingSemArquivo,
              }}
            />
          )}
          {opcoes[selectedNavBar].name === 'Usuários' && (
            <Usuarios
              {...{
                totalUser,
                novosUser,
                PfUser,
                PjUser,
                PjMeiUser,
                PjMeUser,
                PjEppUser,
                PjOutrosUser,
                AtivosAgoraUser,
                AtivosAgoraPfUser,
                AtivosAgoraPjUser,
                ufUser,
                isLoadingTotalUser,
                isLoadingNovosUser,
                isLoadingPfUser,
                isLoadingPjUser,
                isLoadingPjMeiUser,
                isLoadingPjMeUser,
                isLoadingPjEppUser,
                isLoadingPjOutrosUser,
                isLoadingAtivosAgoraUser,
                isLoadingAtivosAgoraPfUser,
                isLoadingAtivosAgoraPjUser,
                isLoadingUfUser,
              }}
            />
          )}
          {opcoes[selectedNavBar].name === 'Acessos' && (
            <Acessos
              {...{
                totalAcessos,
                usuariosUnicosAcessos,
                mediaUsuarioAcessos,
                distribuicaoDiaAcessos,
                perfilUsuarioAcessos,
                porcemPerfilUserAcessos,
                porteAcessos,
                tempoMedioAcessos,
                ufAcessos,
                isLoadingTotalAcessos,
                isLoadingUsuariosUnicosAcessos,
                isLoadingMediaUsuarioAcessos,
                isLoadingDistribuicaoDiaAcessos,
                isLoadingPerfilUsuariosAcessos,
                isLoadingPorcemPerfilUserAcessos,
                isLoadingPorteAcessos,
                isLoadingTempoMedioAcessos,
                isLoadingUfAcessos,
                isLoadingUfUnicoAcessos,
              }}
            />
          )}

          {opcoes[selectedNavBar].name === 'Recorrências' && (
            <Recorrencias
              {...{
                recorrenciaPjSse,
                recorrenciaPjSas,
                recorrenciaPjMeiSas,
                recorrenciaPjMeSas,
                recorrenciaPjEppSas,

                isLoadingRecorrenciaPjSse,
                isLoadingRecorrenciaPjSas,
                isLoadingRecorrenciaPjMeiSas,
                isLoadingRecorrenciaPjMeSas,
                isLoadingRecorrenciaPjEppSas,
              }}
            />
          )}

          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            isLoading.data && <BaSeLoadingPage />}

          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data.itens &&
            data?.itens.map((dt, i) => {
              const min = Math.min(...dt.historico.map((ht) => ht.valor));
              const max = Math.max(...dt.historico.map((ht) => ht.valor));
              return (
                <VictoryGraph key={i.toString()} el={dt} min={min} max={max} />
              );
            })}

          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data.atendimentosPorPorte &&
            data?.atendimentosPorPorte.map((dt, i) => {
              const min = Math.min(...dt.historico.map((ht) => ht.valor));
              const max = Math.max(...dt.historico.map((ht) => ht.valor));
              return (
                <VictoryGraph key={i.toString()} el={dt} min={min} max={max} />
              );
            })}
          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data.tiposRealizacao &&
            data?.tiposRealizacao.map((dt, i) => {
              const min = Math.min(...dt.historico.map((ht) => ht.valor));
              const max = Math.max(...dt.historico.map((ht) => ht.valor));
              return (
                <VictoryGraph key={i.toString()} el={dt} min={min} max={max} />
              );
            })}
          {/* TIPO DE INFO DE CIRCLE PROGRESS */}
          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data?.scoreMedio && <CircularGraph el={data?.scoreMedio} />}

          {/* //TIPOS DE GRÁFICO BARRA */}
          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data.rankItens &&
            data?.rankItens?.map((el) => {
              return renderDash(el);
            })}

          {opcoes[selectedNavBar].name !== 'Registros (SAS)' &&
            opcoes[selectedNavBar].name !== 'Atendimentos SSE' &&
            opcoes[selectedNavBar].name !== 'Usuários' &&
            opcoes[selectedNavBar].name !== 'Acessos' &&
            opcoes[selectedNavBar].name !== 'Relatórios' &&
            opcoes[selectedNavBar].name !== 'Recorrências' &&
            !isLoading.data &&
            data?.resultadosPorNivel && (
              <GeneralGraphBar el={data?.resultadosPorNivel} />
            )}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {!isError && renderHeader()}
      <div className="main-container">
        {isError && <BaSeErrorPage />}
        {!isError && renderInfoContainer()}
        {!isError && renderDestaqueContainer()}
      </div>
    </div>
  );
};

export default Dashboard;
